import { ThirdPartyLoginService } from "@app/core/user/domain/services/third-party-login.service";
import { ThirdPartyLoginCredentials } from "@app/core/user/domain/third-party-login-credentials";
import { Observable } from "rxjs";
import { LoginResponse } from "@app/core/user/domain/login.reponse";
import { LoginWithGoogleWS } from "@app/core/user/data/network/login-with-google.ws";
import { LoginWithFacebookWS } from "@app/core/user/data/network/login-with-facebook.ws";
import { LoginWithAppleWS } from "@app/core/user/data/network/login-with-apple.ws";
import { ThirdPartyLoginProvider } from "@app/core/user/domain/third-party-login-provider";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ThirdPartyLoginActionService implements ThirdPartyLoginService {
  constructor(
    private loginWithGoogleWS: LoginWithGoogleWS,
    private loginWithFacebookWS: LoginWithFacebookWS,
    private loginWithAppleWS: LoginWithAppleWS
  ) {}
  execute(credentials: ThirdPartyLoginCredentials): Observable<LoginResponse> {
    switch (credentials.provider) {
      case ThirdPartyLoginProvider.Google:
        return this.loginWithGoogleWS.execute(credentials);
      case ThirdPartyLoginProvider.Facebook:
        return this.loginWithFacebookWS.execute(credentials);
      case ThirdPartyLoginProvider.Apple:
        return this.loginWithAppleWS.execute(credentials);
      default:
        throw new Error("Unknown third party login provider");
    }
  }
}
